// extracted by mini-css-extract-plugin
export var chevron = "_kg-2";
export var chevronRotated = "_kg-3";
export var header = "_kg-1";
export var section = "_kg-0";